<section id="section-report" class="container-fluid mt-1">
  <div class="row">
    <div id="container-report" class="col-12 col-lg-12">
      <table id="main-table">
        <thead>
          <tr>
            <th id="th-head">
              <div class="row">
                <div id="head-{{transferWorkshopStorePrintModel.transferWorkshopStoreId}}"
                  class="head col-12 col-lg-12">
                  <!-- Logo -->
                  <img id="logo-{{transferWorkshopStorePrintModel.transferWorkshopStoreId}}" [src]="logoEnterprise"
                    alt="" (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                  <!--Nombre Empresa -->
                  <p id="nombre-empresa-{{transferWorkshopStorePrintModel.transferWorkshopStoreId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"> {{nameEnterprise}}</p>
                  <!--Nombre Sucursal -->
                  <p id="nombre-sucursal-{{transferWorkshopStorePrintModel.transferWorkshopStoreId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{transferWorkshopStorePrintModel.branchName}}</p>
                  <!-- Traslado Taller Almacén Consecutivo -->
                  <label id="t-traslado-taller-almacen-{{transferWorkshopStorePrintModel.transferWorkshopStoreId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-traslado-taller-almacen' |
                    formatLabelPipe : elementsLabel}}
                  </label>
                  <p id="traslado-taller-almacen-{{transferWorkshopStorePrintModel.transferWorkshopStoreId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{transferWorkshopStorePrintModel.consecutive}}</p>
                  <!-- Numero Alterno Traslado Taller Almacén -->
                  <label id="t-traslado-taller-almacen-alt-{{transferWorkshopStorePrintModel.transferWorkshopStoreId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-traslado-taller-almacen-alt' |
                    formatLabelPipe : elementsLabel}}
                  </label>
                  <p id="traslado-taller-almacen-alt-{{transferWorkshopStorePrintModel.transferWorkshopStoreId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{transferWorkshopStorePrintModel.alterNumber}}</p>
                  <!--Dirección  -->
                  <label id="t-direccion-{{transferWorkshopStorePrintModel.transferWorkshopStoreId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-direccion'
                    | formatLabelPipe : elementsLabel}}</label>
                  <p id="direccion-{{transferWorkshopStorePrintModel.transferWorkshopStoreId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{transferWorkshopStorePrintModel.branchAddress}}</p>
                  <!--Teléfono  -->
                  <label id="t-telefono-{{transferWorkshopStorePrintModel.transferWorkshopStoreId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-telefono' |
                    formatLabelPipe : elementsLabel}}
                  </label>
                  <p id="telefono-{{transferWorkshopStorePrintModel.transferWorkshopStoreId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{transferWorkshopStorePrintModel.branchPhone}}</p>
                  <!-- Fecha Traslado -->
                  <label
                    id="t-fecha-traslado-taller-almacen-{{transferWorkshopStorePrintModel.transferWorkshopStoreId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-fecha-traslado-taller-almacen' |
                    formatLabelPipe : elementsLabel}}</label>
                  <p id="fecha-traslado-taller-almacen-{{transferWorkshopStorePrintModel.transferWorkshopStoreId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{transferWorkshopStorePrintModel.dateTransferWorkshopStore | date: 'dd/MM/yyyy'}}</p>
                  <!-- Tipo Traslado -->
                  <label id="t-tipo-traslado-taller-almacen-{{transferWorkshopStorePrintModel.transferWorkshopStoreId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-tipo-traslado-taller-almacen' |
                    formatLabelPipe : elementsLabel}}</label>
                  <p id="tipo-traslado-taller-almacen-{{transferWorkshopStorePrintModel.transferWorkshopStoreId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{transferWorkshopStorePrintModel.typeTransferWorkshopStore}}</p>
                  <!-- Estado Traslado -->
                  <label
                    id="t-estado-traslado-taller-almacen-{{transferWorkshopStorePrintModel.transferWorkshopStoreId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-estado-traslado-taller-almacen' |
                    formatLabelPipe : elementsLabel}}</label>
                  <p id="estado-traslado-taller-almacen-{{transferWorkshopStorePrintModel.transferWorkshopStoreId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{transferWorkshopStorePrintModel.stateTransferWorkshopStore}}</p>
                </div>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <div class="table-container">
                <app-custom-table-print
                  id="detalle-traslado-taller-almacen-{{transferWorkshopStorePrintModel.transferWorkshopStoreId}}"
                  [columns]="columns" [data]="transferWorkshopStorePrintModel.transferWorkshopStoreDetails"
                  [idMap]="idMap" [documentId]="transferWorkshopStorePrintModel.transferWorkshopStoreId"
                  [footerVisible]="true" [editFormat]="editFormat" (clickTableEvent)="clickTable($event)"
                  (newIndexColumns)="onColumnReorder($event)"></app-custom-table-print>
              </div>
              <div id="foot-{{transferWorkshopStorePrintModel.transferWorkshopStoreId}}"
                class="foot mt-1 container-observations">
                <!-- Observaciones -->
                <label id="t-obs-traslado-taller-almacen-{{transferWorkshopStorePrintModel.transferWorkshopStoreId}}"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-obs-traslado-taller-almacen' |
                  formatLabelPipe : elementsLabel}}</label>
                <p id="obs-traslado-taller-almacen-{{transferWorkshopStorePrintModel.transferWorkshopStoreId}}"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"
                  *ngIf="transferWorkshopStorePrintModel.observation">
                  {{transferWorkshopStorePrintModel.observation}}</p>
                <p id="linea-firma-revisado-{{transferWorkshopStorePrintModel.transferWorkshopStoreId}}"
                  class="write-line" (click)="onClick()" (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                </p>
                <label id="t-linea-revisado-{{transferWorkshopStorePrintModel.transferWorkshopStoreId}}"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-linea-revisado' | formatLabelPipe :
                  elementsLabel}}</label>
                <p id="linea-firma-entregado-{{transferWorkshopStorePrintModel.transferWorkshopStoreId}}"
                  class="write-line" (click)="onClick()" (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                </p>
                <label id="t-linea-entregado-{{transferWorkshopStorePrintModel.transferWorkshopStoreId}}"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-linea-entregado' | formatLabelPipe
                  : elementsLabel}}</label>
              </div>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td colspan="1" id="td-foot">
              <div class="information-print d-flex">
                <p id="version-cervino" class="fw-bold pe-4 ">{{version}}</p>
                <label id="t-fecha-impresion" class="fw-bold pe-2">Fecha: </label>
                <p id="fecha-impresion" class="pe-4">{{dateNow | date: 'dd/MM/yyyy'}}</p>
                <label id="t-hora-impresion" class="fw-bold pe-2">Hora: </label>
                <p id="hora-impresion" class="pe-4"> {{dateNow | date: 'hh:mm:ss a'}}</p>
                <label id="t-usuario-impresion" class="fw-bold pe-2">Usuario: </label>
                <p id="usuario-impresion" class="pe-4"> {{transferWorkshopStorePrintModel.userAuthenticated}}</p>
              </div>
              <div class="d-flex flex-column justify-content-center">
                <div class="d-flex justify-content-center">
                  <p class="mt-2 information-print">Documento generado con el Software Cervino Web de Altos Software
                    SAS. Nit.811.022.121-1. www.altos-soft.com</p>
                </div>
              </div>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</section>